module.exports = __webpack_public_path__ + "img/refresh-cw-05.273e2f2c.svg";